import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { vfRut } from '@avla/ui-design/commons';
import { UsersService } from '@services/private/users.service';
import { RolesSI } from '@views/interfaces/services/users.interface';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {
  public newUserForm: FormGroup;
  @Output() newItemEvent = new EventEmitter();
  @Input() roles: RolesSI[];
  public status:string = "default";

  constructor(
    private formBuilder: FormBuilder,    
    private usersService: UsersService
  ) { }

  public height: number = window.innerHeight;
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.height = window.innerHeight;
  }


  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.newUserForm = this.formBuilder.group({
      rut: ['', [Validators.required, vfRut()]],
      firstName: ['', [Validators.required]],
      secondName: ['', []],
      fatherLastname: ['', [Validators.required]],
      motherLastname: ['', [Validators.required]],
      email: ['', [Validators.required]],
      role: ['', [Validators.required]],
    });
  }

  reInit() {
    this.status = "default";
    setTimeout(() => {
      this.newUserForm.reset();
    });
  }
  
  async register() {
    if (this.newUserForm.valid) {
      this.status = "loading";
      const body = this.newUserForm.value;
      const role = body.role;
      if(Object.keys(role).length==0) {
        body.role = this.roles.find(x => x.key == body.role);
      }
      try {
        await this.usersService.register(body);
        this.status = "success";
      } catch (error) {
        if (error.error.message == "USER_ALREADY_EXISTS") {
          this.status = "default";
          setTimeout(() => {
            Object.keys(this.newUserForm.controls).forEach((campo) => {
              const control = this.newUserForm.get(campo);
              control.updateValueAndValidity();
            });
          }); 
        } else
          this.status = "error";
      }
    }
  }

  close(){
    this.newItemEvent.emit();
    setTimeout(() => {
      this.newUserForm.reset();
      this.status = "default";
    });
  }

}
